export default __webpack_public_path__ + "static/media/Prancheta EV.15de0b6c.svg";